// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1q4125m0 {
  padding-top: var(--_18w76bwb);
  padding-bottom: var(--_18w76bwb);
  padding-left: var(--_18w76bw9);
  padding-right: var(--_18w76bw9);
  border-radius: 0;
  justify-content: center;
  font-size: var(--_18w76bw3v);
}
._1q4125m1 {
  margin-top: var(--_18w76bw9);
  margin-bottom: var(--_18w76bwb);
}
._1q4125m2 {
  text-decoration: underline;
  cursor: pointer;
}
._1q4125m3 {
  font-size: var(--_18w76bw3p);
}
._1q4125m4 {
  font-size: var(--_18w76bw3q);
}
._1q4125m5 {
  font-size: var(--_18w76bw3r);
}
._1q4125m6 {
  font-size: var(--_18w76bw3s);
}
._1q4125m7 {
  font-size: var(--_18w76bw3t);
}
._1q4125m8 {
  font-size: var(--_18w76bw3u);
}
._1q4125m9 {
  font-size: var(--_18w76bw3v);
}
._1q4125ma {
  line-height: 20px;
  margin-top: var(--_18w76bwc);
  margin-bottom: var(--_18w76bwc);
  margin-left: var(--_18w76bw9);
  margin-right: var(--_18w76bw9);
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;EAChB,uBAAuB;EACvB,4BAA4B;AAC9B;AACA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;EACE,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,+BAA+B;EAC/B,6BAA6B;EAC7B,8BAA8B;AAChC","sourcesContent":["._1q4125m0 {\n  padding-top: var(--_18w76bwb);\n  padding-bottom: var(--_18w76bwb);\n  padding-left: var(--_18w76bw9);\n  padding-right: var(--_18w76bw9);\n  border-radius: 0;\n  justify-content: center;\n  font-size: var(--_18w76bw3v);\n}\n._1q4125m1 {\n  margin-top: var(--_18w76bw9);\n  margin-bottom: var(--_18w76bwb);\n}\n._1q4125m2 {\n  text-decoration: underline;\n  cursor: pointer;\n}\n._1q4125m3 {\n  font-size: var(--_18w76bw3p);\n}\n._1q4125m4 {\n  font-size: var(--_18w76bw3q);\n}\n._1q4125m5 {\n  font-size: var(--_18w76bw3r);\n}\n._1q4125m6 {\n  font-size: var(--_18w76bw3s);\n}\n._1q4125m7 {\n  font-size: var(--_18w76bw3t);\n}\n._1q4125m8 {\n  font-size: var(--_18w76bw3u);\n}\n._1q4125m9 {\n  font-size: var(--_18w76bw3v);\n}\n._1q4125ma {\n  line-height: 20px;\n  margin-top: var(--_18w76bwc);\n  margin-bottom: var(--_18w76bwc);\n  margin-left: var(--_18w76bw9);\n  margin-right: var(--_18w76bw9);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
